import DvrIcon from "@mui/icons-material/Dvr"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemAvatar from "@mui/material/ListItemAvatar"
import ListItemText from "@mui/material/ListItemText"
import { useDispatch, useSelector } from "react-redux"
import { servicePackageServiceInsert } from "../store/actions"

export const SelectServiceDialog = ({ onCloseFunc, isOpen, spId, phase }) => {
	const service = useSelector((state) => state.serviceReducer)
	const servicepackageservice = useSelector((state) => state.servicePackageServiceReducer)

	const dispatch = useDispatch()
	const spsInsert = (data) => dispatch(servicePackageServiceInsert(data))

	const handleSelect = (value) => {
		const data = {
			serviceid: value,
			servicepackageid: spId,
			phaseid: phase,
		}
		spsInsert(data)
		onCloseFunc()
	}

	let sps = servicepackageservice.filter((obj) => {
		return obj.servicepackageid === spId && obj.phaseid === phase
	})
	return (
		<>
			{spId !== null ? (
				<Dialog onClose={onCloseFunc} aria-labelledby="simple-dialog-title" open={isOpen}>
					<DialogTitle id="simple-dialog-title">Valitse Palvelu</DialogTitle>
					<List>
						{service.map((sObj, i) => {
							let match = false
							for (const spsLine of sps) {
								if (Number(spsLine.serviceid) === Number(sObj.serviceid)) {
									match = true
								}
							}
							if (match === false) {
								return (
									<ListItem button onClick={() => handleSelect(sObj.serviceid)} key={"servicelist" + i}>
										<ListItemAvatar>
											<DvrIcon />
										</ListItemAvatar>
										<ListItemText primary={sObj.title} secondary={sObj.description} />
									</ListItem>
								)
							}
							return null
						})}
					</List>
				</Dialog>
			) : (
				<></>
			)}
		</>
	)
}
